export default function WeeklyGol() {
  return (
    <div
      className="m-5 bg-white h-[80vh]"
      dangerouslySetInnerHTML={{
        __html: `<iframe
      class="clickup-embed clickup-dynamic-height"
      src="https://doc.clickup.com/9016726391/d/h/8cq0mvq-1536/ff4e70a1c88ccbe"
      onwheel=""
      width="100%"
      height="100%"
      style="background: transparent; border: 1px solid #ccc"
    ></iframe>
    <script
      async
      src="https://app-cdn.clickup.com/assets/js/forms-embed/v1.js"
    ></script>`,
      }}
    ></div>
  );
}
